import React, {useState, useEffect} from 'react'
import ImageTile from './ImageTile';

const ImageGallery = () => {
  const [images, setImages] = useState([]);
  const [isUploading, setIsUploading] = useState(false);
  const [page, setPage] = useState(1);
  const reference = document.querySelector('.js-reference').dataset
  const [selectedImages, setSelectedImages] = useState([]);

  useEffect(() => {   
    fetchImages();
  }, []); 

  
  async function fetchImages() {
    const placeName = reference.name;
    const selectElement = document.querySelector('.js-place-image-api-source');
    console.log('Fetching images for place:', placeName, 'using API source:', selectElement.value);
    try {
      const response = await fetch(`/get_pictures_for_place?place_name=${encodeURIComponent(placeName)}&page=${page}&api_source=${selectElement.value}`);
      const data = await response.json();
      if (data.photos) {
        setImages(prev => [...prev, ...data.photos]);
      }
    } catch (error) {
      console.error('Error fetching images:', error);
    }
    setPage(prev => prev + 1);
  }

  const handleUpload = async () => {
    setIsUploading(true);
    if (selectedImages.length === 0) return;

    try {
      const response = await fetch('/save_pictures_for_reference', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
        },
        body: JSON.stringify({
          reference_id: reference.reference_id,
          reference_type: reference.reference_type,
          api_source: document.querySelector('.js-place-image-api-source').value,
          images: selectedImages,

        })
      });

      if (!response.ok) throw new Error('Upload failed');
      
      // Reset selection after successful upload
      setSelectedImages([]);
      alert('Images uploaded successfully!');
      setIsUploading(false);
    } catch (err) {
      setError(err.message);
    }
  };

  return(
    <div className="place-image-selector">
      <div className="image-grid">
        {images.map((image, index) => (
          <ImageTile
            key={index}
            imageUrl={image.url}
            imageId={image.id}
            index={index}
            selectedImages={selectedImages}
            setSelectedImages={setSelectedImages}
          />
        ))}
      </div>

      {images.length > 0 && (
        <div>
          {isUploading ? <p>Uploading...</p> : 
            <div className="upload-controls">
              <button 
                onClick={handleUpload}
                disabled={selectedImages.length === 0}
              >
                Upload Selected Images ({selectedImages.length})
              </button>
              <button onClick={()=> fetchImages()}>
                Load more
              </button>
            </div>
          }
        </div>
      )}
      </div>
  )
}

export default ImageGallery;
